import { useEffect } from 'react';
import { useUser } from '@dfl/react-security';
import PushNotificationService from 'modules/notification/services/push-notification.service';

/**
 * App-wide listener for FCM messages received while the tab is open.
 * Mounted once at the provider level so foreground notifications work on
 * every authenticated screen, independent of the account menu.
 */
export const useForegroundPushNotifications = () => {
  const { user } = useUser();

  useEffect(() => {
    if (!user) return;

    let unsubscribe: () => void = () => undefined;
    PushNotificationService.subscribeToForegroundMessages((payload) => {
      if (Notification.permission !== 'granted' || document.visibilityState === 'visible') return;
      const notification = new Notification(payload.notification?.title || 'Notificación', {
        body: payload.notification?.body,
        data: payload.data,
      });
      notification.onclick = () => { window.focus(); };
    })
      .then((cleanup) => {
        unsubscribe = cleanup;
      })
      .catch((error) => { console.error('Unable to subscribe to push notifications', error); });

    return () => { unsubscribe(); };
  }, [user]);
};
